import { createAction } from '@nike/redux-action-utils'

import { redirectForToken, getTokenIfPresent } from '../auth/oAuth.js'

export const setToken = createAction('TOKEN_SET')
export const setError = createAction('ERROR_SET')

export const getRedirectToken = () => (dispatch, getState) => {
  let token = getTokenIfPresent()
  if (!token) return null
  if (token.error) {
    dispatch(setError(token.error))
    return
  }
  dispatch(setToken(token))
}

export const oAuthLogin = config => {
  redirectForToken(config)
}
